import {useDispatch, useSelector} from "react-redux";
import i18n from 'examsbook-react-sdk/translations';
import {updateUser} from "examsbook-react-sdk/actions/getUser";
import {Platform} from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Hook to set default language of user.
 * this returns language and setter.
 * @returns {{defaultLanguage: (*|string), setUserLanguage: setUserLanguage}}
 */
export default function useUserLanguage(){
    const user = useSelector((state)=>state.user);
    const language = user.language || 'en';
    const dispatch = useDispatch();
    //language setter.
    function setUserLanguage(lang = 'en') {
        i18n.changeLanguage(lang);
        if (Platform.OS === 'web'){
            localStorage.setItem('langugae', lang);
        }
        else {
            AsyncStorage.setItem('USER_LANGUAGE', lang, ()=>{});
        }
        if (user && user.language !== lang) {
            dispatch(updateUser(user._id, {language : lang}));
        }
    }
    return {
        language,
        setUserLanguage
    }
}
